// translations.ts
export const translations = {
  accounts: {
    en: "Accounts",
    zh: "账户",
  },
  settings: {
    en: "Settings",
    zh: "设置",
  },
  logout: {
    en: "Logout",
    zh: "登出",
  },
  home: {
    en: "Home",
    zh: "主页",
  },
  help: {
    en: "Help",
    zh: "帮助",
  },
  searchPlaceholder: {
    en: "Search...",
    zh: "搜索...",
  },
  cancel: {
    en: "Cancel",
    zh: "取消",
  },
  hubspot: {
    en: "Hubspot",
    zh: "集线器点",
  },
  reports: {
    en: "Reports",
    zh: "报告",
  },
  containers: {
    en: "Containers",
    zh: "集装箱",
  },
  operations: {
    en: "Operations",
    zh: "运营",
  },
  totalContainers: {
    en: "Total Containers",
    zh: "集装箱总数",
  },
  searchBy: {
    en: "Search by",
    zh: "搜索方式",
  },
  deliverTo: {
    en: "Deliver To",
    zh: "送货至",
  },
  container: {
    en: "Container",
    zh: "集装箱",
  },
  noDataAvailable: {
    en: "No Data Available",
    zh: "暂无数据",
  },
  rowsPerPage: {
    en: "Rows per page",
    zh: "每页行数",
  },
  delivery: {
    en: "Delivery",
    zh: "送货",
  },
  orderDelivery: {
    en: "Order/Delivery",
    zh: "订单/送货",
  },
  tracker: {
    en: "Tracker",
    zh: "追踪",
  },
  description: {
    en: "Description",
    zh: "说明",
  },
  packingNo: {
    en: "Packing #",
    zh: "装箱单号",
  },
  operationalScans: {
    en: "OperationalScans",
    zh: "操作扫描",
  },
  production: {
    en: "Production",
    zh: "生产",
  },
  accountSettings: {
    en: "Account Settings",
    zh: "账户设置",
  },
  userSettings: {
    en: "User Settings",
    zh: "用户设置",
  },
  usersManagement: {
    en: "Users Management",
    zh: "用户管理",
  },
  organizationSettings: {
    en: "Organisation Settings",
    zh: "组织设置",
  },
  organizationManagement: {
    en: "Organisation Management",
    zh: "组织管理",
  },
  notifications: {
    en: "Notifications",
    zh: "通知",
  },
  signOut: {
    en: "Sign Out",
    zh: "登出",
  },
  productTrackerReport: {
    en: "Product Tracker Report",
    zh: "产品追踪报告",
  },
  manageContainer: {
    en: "Manage Container",
    zh: "管理集装箱",
  },
  customerOrderSummaryReport: {
    en: "Customer Order Summary Report",
    zh: "客户订单摘要报告",
  },
  producttrackerdetailsreport: {
    en: "ProductTrackerDetailsReport",
    zh: "产品追踪详情报告",
  },
  notification: {
    en: "Notification",
    zh: "通知",
  },
  dynamicWidth: {
    en: "Dynamic Width",
    zh: "动态宽度",
  },
  productionStockDetails: {
    en: "Production Stock Details",
    zh: "生产库存详情",
  },
  chinaShipmentReport: {
    en: "China Shipment Report",
    zh: "中国发货报告",
  },
  company: {
    en: "Company",
    zh: "公司",
  },
  multistepsGo: {
    en: "Multisteps GO",
    zh: "Multisteps GO",
  },
  kanbanpocscreen: {
    en: "KanbanPOCScreen",
    zh: "看板 POC 屏幕",
  },
  stockTransferReport: {
    en: "Stock Transfer Report",
    zh: "库存转移报告",
  },
  inventoryDetailReport: {
    en: "Inventory Detail Report",
    zh: "库存详情报告",
  },
  dynamicWidthScreen: {
    en: "Dynamic Width Screen",
    zh: "动态宽度屏幕",
  },
  containersManagement: {
    en: "Containers Management",
    zh: "集装箱管理",
  },
  teams: {
    en: "Teams",
    zh: "团队",
  },
  customerIssueReport: {
    en: "Customer Issue Report",
    zh: "客户问题报告",
  },
  globalShipmentReport: {
    en: "Global Shipment Report",
    zh: "全球发货报告",
  },
  customerOrderDashboard: {
    en: "Customer Order Dashboard",
    zh: "客户订单仪表板",
  },
  profile: {
    en: "Profile",
    zh: "个人资料",
  },
  customerStatusDetails: {
    en: "Customer Status Details",
    zh: "客户状态详情",
  },
  customerIssueScreen: {
    en: "Customer Issue Screen",
    zh: "客户问题屏幕",
  },
  kanbanPoc: {
    en: "Kanban POC",
    zh: "看板 POC",
  },
  prepayOrderRequest: {
    en: "Prepay Order Request",
    zh: "预付订单请求",
  },
  customerissuereport: {
    en: "CustomerIssueReport",
    zh: "客户问题报告",
  },
  artwork: {
    en: "Artwork",
    zh: "艺术作品",
  },
  multistepsGoResetPassword: {
    en: "Multisteps GO | Reset Password",
    zh: "Multisteps GO | 重置密码",
  },
  chinaTrackerReport: {
    en: "China Tracker Report",
    zh: "中国追踪报告",
  },
  customerIssueSummaryReport: {
    en: "Customer Issue Summary Report",
    zh: "客户问题摘要报告",
  },
  globalshipment: {
    en: "GlobalShipment",
    zh: "全球发货",
  },
  customerOrderScreen: {
    en: "Customer Order Screen",
    zh: "客户订单屏幕",
  },
  users: {
    en: "Users",
    zh: "用户",
  },
  producttracker: {
    en: "ProductTracker",
    zh: "产品追踪",
  },
  createCompany: {
    en: "Create Company",
    zh: "创建公司",
  },
  inventoryOverviewDetails: {
    en: "Inventory Overview Details",
    zh: "库存总览详情",
  },
  globalshipmentdetailsreport: {
    en: "GlobalShipmentDetailsReport",
    zh: "全球发货详情报告",
  },
  manageOperations: {
    en: "Manage Operations",
    zh: "运营管理",
  },
  itemsManagement: {
    en: "Items Management",
    zh: "物品管理",
  },
  scanResults: {
    en: "Scan Results",
    zh: "扫描结果",
  },
  productionDashboard: {
    en: "Production Dashboard",
    zh: "生产仪表板",
  },
  addArtwork: {
    en: "Add Artwork",
    zh: "添加艺术作品",
  },
  reserveOrderRequest: {
    en: "Reserve Order Request",
    zh: "预留订单请求",
  },
  kanbanPocReport: {
    en: "Kanban POC Report",
    zh: "看板 POC 报告",
  },
  chinashipment: {
    en: "ChinaShipment",
    zh: "中国发货",
  },
  chinatracker: {
    en: "ChinaTracker",
    zh: "中国追踪",
  },
  containersStatus: {
    en: "Containers Status",
    zh: "集装箱状态",
  },
  operationsStatus: {
    en: "Operations Status",
    zh: "运营状态",
  },
  addContainer: {
    en: "Add Container",
    zh: "添加集装箱",
  },
  addOperations: {
    en: "Add Operations",
    zh: "添加运营",
  },
  addOperation: {
    en: "Add Operation",
    zh: "添加运营",
  },
  trackerDashboardReport: {
    en: "Tracker Dashboard Report",
    zh: "追踪仪表板报告",
  },
  trackerdashboard: {
    en: "TrackerDashboard",
    zh: "追踪仪表板",
  },
  artworkManagement: {
    en: "Artwork Management",
    zh: "艺术作品管理",
  },
  operationsDetails: {
    en: "Operations Details",
    zh: "运营详情",
  },
  chinatrackerdetailsreport: {
    en: "ChinaTrackerDetailsReport",
    zh: "中国追踪详情报告",
  },
  customerorderreport: {
    en: "CustomerOrderReport",
    zh: "客户订单报告",
  },
  customerordersummaryreport: {
    en: "CustomerOrderSummaryReport",
    zh: "客户订单摘要报告",
  },
  orderRequest: {
    en: "Order Request",
    zh: "订单请求",
  },
  chinaTracker: {
    en: "China Tracker",
    zh: "中国追踪",
  },
  customerissuedetailsreport: {
    en: "CustomerIssueDetailsReport",
    zh: "客户问题详情报告",
  },
  stockTransfer: {
    en: "Stock Transfer",
    zh: "库存转移",
  },
  operationsManagement: {
    en: "Operations Management",
    zh: "运营管理",
  },
  chinashipmentdetailsreport: {
    en: "ChinaShipmentDetailsReport",
    zh: "中国发货详情报告",
  },
  placeOrderRequest: {
    en: "Place Order Request",
    zh: "下订单请求",
  },
  customerOrderTracker: {
    en: "Customer Order Tracker",
    zh: "追踪客户订单",
  },
  chinaOrderTracker: {
    en: "China Order Tracker",
    zh: "追踪中国订单",
  },
  incomingStatus: {
    en: "Incoming Status",
    zh: "传入状态",
  },
  trackerDashboard: {
    en: "Tracker Dashboard",
    zh: "追踪器仪表板",
  },
  // Customer Order Tracker
  orderNumber: {
    en: "Order No",
    zh: "订单号",
  },
  itemCode: {
    en: "Item Code",
    zh: "商品代码",
  },
  documentType: {
    en: "Document Type",
    zh: "文件类型",
  },
  customerRef: {
    en: "Customer Ref#",
    zh: "客户参考号",
  },
  deliveryAddress: {
    en: "Delivery Address",
    zh: "送货地址",
  },
  chinaItemCode: {
    en: "China Item Code",
    zh: "中国商品代码",
  },
  globalItemCode: {
    en: "Item Code",
    zh: "商品代码",
  },
  itemName: {
    en: "Item Name",
    zh: "商品名称",
  },
  customerName: {
    en: "Customer Name",
    zh: "客户名称",
  },
  orderDate: {
    en: "Order Date",
    zh: "订购日期",
  },
  orderQty: {
    en: "Order Qty",
    zh: "订单数量",
  },
  Qty: {
    en: "Qty",
    zh: "数量",
  },
  gwTotal: {
    en: "Gross Weight",
    zh: "毛重",
  },
  nwTotal: {
    en: "Net Weight",
    zh: "净重",
  },
  progress: {
    en: "Progress",
    zh: "进度",
  },
  requestDate: {
    en: "Request Date",
    zh: "请求日期",
  },
  location: {
    en: "Location",
    zh: "地点",
  },
  state: {
    en: "State",
    zh: "省份",
  },
  daysLeft: {
    en: "Days Left",
    zh: "剩余天数",
  },
  orderStatus: {
    en: "Order Status",
    zh: "订单状态",
  },
  actions: {
    en: "Actions",
    zh: "操作",
  },
  orderNo: {
    en: "Order No",
    zh: "订单号",
  },
  docNumbers: {
    en: "Doc Numbers",
    zh: "文件编号",
  },
  organization: {
    en: "Organization",
    zh: "组织",
  },
  requestType: {
    en: "Request Type",
    zh: "请求类型",
  },
  totalItems: {
    en: "Total Items",
    zh: "总项目",
  },
  orderInformation: {
    en: "Order Information",
    zh: "订单信息",
  },
  subOrganization: {
    en: "Sub Organization",
    zh: "子组织",
  },
  exportCsv: {
    en: "Export CSV",
    zh: "导出 CSV",
  },
  exportJson: {
    en: "Export JSON",
    zh: "导出 JSON",
  },
  orderItems: {
    en: "Order Items",
    zh: "订单项目",
  },
  qty: {
    en: "Qty",
    zh: "数量",
  },
  requiredDate: {
    en: "Required Date",
    zh: "需求日期",
  },
  perCarton: {
    en: "Per Carton",
    zh: "每箱",
  },
  perPallet: {
    en: "Per Pallet",
    zh: "每托盘",
  },
  documentNumber: {
    en: "Document Number",
    zh: "文件号码",
  },
  viewDnAttachment: {
    en: "View DN Attachment",
    zh: "查看交货单附件",
  },
  noDnAttachment: {
    en: "No DN attachment",
    zh: "无交货单附件",
  },
  appointment: {
    en: "Appointment",
    zh: "预约",
  },
  quickFilter: {
    en: "Quick Filter",
    zh: "快速过滤器",
  },
  totalDelivery: {
    en: "Total Delivery",
    zh: "送货总数",
  },
  portalOrderNo: {
    en: "Portal Order No",
    zh: "门户订单号",
  },
  documentNo: {
    en: "Document #",
    zh: "文件编号",
  },
  address: {
    en: "Address",
    zh: "地址",
  },
  reference: {
    en: "Reference",
    zh: "参考",
  },
  productGroup: {
    en: "Product Group",
    zh: "产品组",
  },
  deliveryQty: {
    en: "Delivery Qty",
    zh: "交货数量",
  },
  remainingQty: {
    en: "Remaining Qty",
    zh: "剩余数量",
  },
  pallets: {
    en: "Pallets",
    zh: "托盘",
  },
  date: {
    en: "Date",
    zh: "日期",
  },

  updateShipment: {
    en: "Update Shipment",
    zh: "更新发货",
  },

  shipmentActions: {
    en: "Actions",
    zh: "安排",
  },

  // Incoming Statuses
  incoming: {
    en: "Incoming",
    zh: "传入",
  },
  approved: {
    en: "Approved",
    zh: "得到正式认可的",
  },
  rejected: {
    en: "Rejected",
    zh: "被拒绝",
  },
  revised_by_purchasing: {
    en: "REVISED BY PURCHASING",
    zh: "采购部修订",
  },

  // Quick Filters
  all: {
    en: "All",
    zh: "全部",
  },
  onHold: {
    en: "Onhold",
    zh: "搁置",
  },
  closed: {
    en: "Closed",
    zh: "关闭",
  },
  newOrder: {
    en: "New Order",
    zh: "新订单",
  },
  arrived: {
    en: "Arrived",
    zh: "到达的",
  },
  shipped: {
    en: "Shipped",
    zh: "已发货",
  },
  rushOrder: {
    en: "Rush Order",
    zh: "加急订单",
  },
  orderPlaced: {
    en: "Order Placed",
    zh: "已下订单",
  },
  atRisk: {
    en: "At Risk",
    zh: "有风险订单",
  },
  planned: {
    en: "Planned",
    zh: "计划",
  },
  completed: {
    en: "Completed",
    zh: "完全的",
  },
  interrupted: {
    en: "Interrupted",
    zh: "被打断",
  },
  //China tracker
  onTime: {
    en: "On Time",
    zh: "准时交货",
  },
  delayed: {
    en: "Delayed",
    zh: "延迟",
  },
  msRef: {
    en: "MS No",
    zh: "MS订单号",
  },
  priorityOrder: {
    en: "Priority Order",
    zh: "优先订单",
  },

  high: {
    en: "High",
    zh: "高的",
  },

  normal: {
    en: "Normal",
    zh: "普通的",
  },

  add: {
    en: "Add",
    zh: "添加",
  },

  delete: {
    en: "Delete",
    zh: "删除",
  },

  medium: {
    en: "Medium",
    zh: "中等的",
  },

  allocateProductionLine: {
    en: "Prod. Line",
    zh: "生产线",
  },
  artworkNo: {
    en: "Artwork No",
    zh: "贴纸编号",
  },
  qtyToShip: {
    en: "Qty to Ship",
    zh: "剩余未交数量",
  },
  fulfillmentPercent: {
    en: "Fulfilment %",
    zh: "订单履约率",
  },
  ausInventory: {
    en: "Aus Inventory",
    zh: "澳洲库存",
  },
  noData: {
    en: "No Data",
    zh: "没有资料",
  },
  run1: {
    en: "Run 1",
    zh: "生产批次 1",
  },
  run2: {
    en: "Run 2",
    zh: "生产批次 2",
  },
  plannedQuantity: {
    en: "Planned Quantity",
    zh: "计划生产数量",
  },
  artworkNumber: {
    en: "Artwork Number",
    zh: "贴纸编号",
  },
  addMoreRun: {
    en: "Add more run",
    zh: "增加生产次数",
  },
  reviewRejectedOrder: {
    en: "Review rejected order",
    zh: "审查被拒绝订单",
  },
  interruptRunOrder: {
    en: "Interrupt Run Order",
    zh: "中断运行",
  },
  resumeRunOrder: {
    en: "Resume Run Order",
    zh: "恢复运行",
  },
  interruptRunOrderNotice: {
    en: "Interrupting this run order will pause its execution and may impact downstream processes.",
    zh: "中断此运行将会暂停此订单执行，并可能会影响此订单往后的进程。",
  },
  resumeRunOrderNotice: {
    en: "This run order is currently interrupted. Resuming will return it to the normal execution flow.",
    zh: "此运行正处于中断状态。恢复后，它将返回正常的执行流程。",
  },
  productionLine: {
    en: "Production Line",
    zh: "生产线",
  },
  runOrder: {
    en: "Run Order",
    zh: "运行顺序",
  },
  messageRequired: {
    en: "Message is required",
    zh: "消息为必填项",
  },
  explainInterruptRunOrder: {
    en: "Explain why this run order needs to be interrupted...",
    zh: "请提供需要中断此运行的原因。",
  },
  explainResumeRunOrder: {
    en: "Explain why you are resuming this run order...",
    zh: "请提供恢复运行的原因。",
  },
  runOrderResumedSuccess: {
    en: "Run order resumed successfully",
    zh: "运行已成功恢复",
  },
  runOrderInterruptedSuccess: {
    en: "Run order interrupted successfully",
    zh: "运行已成功中断",
  },
  actionFailed: {
    en: "Action failed",
    zh: "操作失败",
  },
  resume: {
    en: "Resume",
    zh: "恢复",
  },
  interrupt: {
    en: "Interrupt",
    zh: "中断",
  },
  newRequest: {
    en: "New request",
    zh: "新要求",
  },
  message: {
    en: "Message",
    zh: "消息",
  },
  awaitingPurchasingApproval: {
    en: "Awaiting purchasing approval",
    zh: "等待确认",
  },
  awaitingForYourResponse: {
    en: "Awaiting for your response",
    zh: "等待工厂回复",
  },
  poOrderDate: {
    en: "PO Order Date",
    zh: "订单日期",
  },
  labelOrder: {
    en: "Label Ready",
    zh: "贴纸已订",
  },
  soakarPad: {
    en: "Soakar Pad",
    zh: "吸水垫",
  },
  directShipment: {
    en: "Direct Shipment",
    zh: "直接发货",
  },
  Run: {
    en: "Run Order",
    zh: "运行顺序",
  },
  planStartDay: {
    en: "Planned Start Date",
    zh: "预计生产日期",
  },
  actualStartDay: {
    en: "Act. Start Date",
    zh: "真实生产日期",
  },
  duration: {
    en: "Duration (Days)",
    zh: "持续时间（天）",
  },

  Duration: {
    en: "Duration (Days)",
    zh: "持续时间（天）",
  },

  actualCompletionDate: {
    en: "Act. Completion Date",
    zh: "实际完成日期",
  },
  expectedArrival: {
    en: "ETA (To Store)",
    zh: "预计到达",
  },
  estCompletion: {
    en: "Est. Completion Date",
    zh: "预计完成日期",
  },
  estPack: {
    en: "Est. Pack",
    zh: "预计装柜日期",
  },
  etd: {
    en: "ETD",
    zh: "ETD",
  },
  eta: {
    en: "ETA",
    zh: "ETA",
  },
  shippingDeadline: {
    en: "Shipping Deadline",
    zh: "最迟起航日期",
  },
  search: {
    en: "Search",
    zh: "搜索",
  },
  searchProduct: {
    en: "Search Product",
    zh: "搜索产品",
  },
  productionStock: {
    en: "Production Stock",
    zh: "生产库存",
  },
  rawMaterialOverview: {
    en: "Raw Material Overview",
    zh: "原材料概览",
  },
  rawMaterialStock: {
    en: "Raw Material Stock",
    zh: "原材料库存",
  },
  inventoryOverview: {
    en: "Inventory Overview",
    zh: "库存概览",
  },
  inventoryDetail: {
    en: "Inventory Detail",
    zh: "库存明细",
  },
  shipmentSearchPlaceholder: {
    en: "Enter Shipment Container Number",
    zh: "请输入货运集装箱编号",
  },

  shippingLine: {
    en: "Shipping Line",
    zh: "船公司",
  },
  newShippingDeadline: {
    en: "New Shipping Deadline",
    zh: "最遲起航日期（新）",
  },
  customer: {
    en: "Customer",
    zh: "客户名称",
  },
  item: {
    en: "Item",
    zh: "商品",
  },
  subject: {
    en: "Subject",
    zh: "主题",
  },
  priority: {
    en: "Priority",
    zh: "优先",
  },
  low: {
    en: "Low",
    zh: "低",
  },
  sealNo: {
    en: "Seal No",
    zh: "封条号",
  },
  selectPriority: {
    en: "Select Priority",
    zh: "选择优先",
  },
  orderIssue: {
    en: "High",
    zh: "订单问题",
  },
  productInquiry: {
    en: "Product Inquiry",
    zh: "产品查询",
  },
  other: {
    en: "Other",
    zh: "其他",
  },
  selectSubject: {
    en: "Select Subject",
    zh: "选择主题",
  },
  prodcutionline: {
    en: "Production Line",
    zh: "生产线",
  },
  incomingOrder: {
    en: "Incoming Shipments",
    zh: "收到订单",
  },

  transferOrder: {
    en: "Transfer Order",
    zh: "调令",
  },

  upcomingMonth: {
    en: "Upcoming Month",
    zh: "未来一个月",
  },
  nextMonth: {
    en: "Next Month",
    zh: "下个月",
  },
  threeMonths: {
    en: "3 Months",
    zh: "三个月",
  },
  sixMonths: {
    en: "6 Months",
    zh: "六个月",
  },
  requestDateAlerts: {
    en: "Alerts",
    zh: "请求日期警报",
  },
  ordersLabel: {
    en: "Orders",
    zh: "订单",
  },
  overdue: {
    en: "Overdue",
    zh: "已逾期",
  },
  next7Days: {
    en: "Next 7 Days",
    zh: "未来7天",
  },
  next14Days: {
    en: "Next 14 Days",
    zh: "未来14天",
  },
  next30Days: {
    en: "Next 30 Days",
    zh: "未来30天",
  },
  loadingOrders: {
    en: "Loading orders...",
    zh: "正在加载订单...",
  },
  loading: {
    en: "Loading...",
    zh: "加载中...",
  },
  noOrdersInTimeframe: {
    en: "No orders in the selected timeframe",
    zh: "所选时间范围内没有订单",
  },
  allCaughtUp: {
    en: "All caught up! Great job staying on schedule.",
    zh: "全部完成！非常棒，继续保持进度。",
  },
  itemLabel: {
    en: "Item",
    zh: "商品",
  },
  codeLabel: {
    en: "Code",
    zh: "代码",
  },
  quantityLabel: {
    en: "Quantity",
    zh: "数量",
  },
  statusLabel: {
    en: "Status",
    zh: "状态",
  },
  generatedStatus: {
    en: "Generated",
    zh: "已生成",
  },
  notGeneratedStatus: {
    en: "Not Generated",
    zh: "未生成",
  },
  today: {
    en: "Today",
    zh: "今天",
  },
  day: {
    en: "day",
    zh: "天",
  },
  days: {
    en: "days",
    zh: "天",
  },
  dayAgo: {
    en: "day ago",
    zh: "天前",
  },
  daysAgo: {
    en: "days ago",
    zh: "天前",
  },
  urgencyOverdue: {
    en: "OVERDUE",
    zh: "已逾期",
  },
  urgencyDueToday: {
    en: "DUE TODAY",
    zh: "今天到期",
  },
  urgencyDueTomorrow: {
    en: "DUE TOMORROW",
    zh: "明天到期",
  },
  urgencyUrgent: {
    en: "URGENT",
    zh: "紧急",
  },
  urgencySoon: {
    en: "SOON",
    zh: "即将",
  },
  urgencyUpcoming: {
    en: "UPCOMING",
    zh: "即将到来",
  },
  urgencyFuture: {
    en: "FUTURE",
    zh: "未来",
  },
  notAvailable: {
    en: "N/A",
    zh: "无",
  },
  checklist: {
    en: "Checklist",
    zh: "清单",
  },
  reviewRejectedOrders: {
    en: "Rejected Orders",
    zh: "审核被拒绝的订单",
  },
  allOrders: {
    en: "All Orders",
    zh: "所有订单",
  },
  pending: {
    en: "Pending",
    zh: "待办",
  },
  rejectedOrders: {
    en: "Rejected Orders",
    zh: "被拒绝的订单",
  },
  cancelledOrders: {
    en: "Cancelled Orders",
    zh: "取消订单",
  },
  archievedOrders: {
    en: "Archived Orders",
    zh: "已归档订单",
  },
  cancelled: {
    en: "Cancelled",
    zh: "取消",
  },
  dueDate: {
    en: "Due Date",
    zh: "到期日",
  },
  newDueDate: {
    en: "New Due Date",
    zh: "到期日（新）",
  },
  newOrderQty: {
    en: "New Order Qty",
    zh: "订单数量（新）",
  },
  flaggedOrderNumber: {
    en: "Flagged Order Number",
    zh: "标记的订单号",
  },
  vesselScheduling: {
    en: "Vessel Full Re-Scheduling",
    zh: "货船行程变更",
  },
  machineBroken: {
    en: "Machine Broken Down",
    zh: "机器故障",
  },
  selectasubejct: {
    en: "Select a subject",
    zh: "选择主题",
  },
  newduedate: {
    en: "New due date",
    zh: "新的到期日",
  },
  neworderqty: {
    en: "New order qty",
    zh: "新的订单数量",
  },

  newshippingdeadline: {
    en: "New shipping dealine",
    zh: "新的出货截止日期",
  },
  close: {
    en: "Close",
    zh: "关闭",
  },
  submit: {
    en: "Submit",
    zh: "提交",
  },
  cancel: {
    en: "Cancel",
    zh: "取消",
  },
  resubmit: {
    en: "Resubmit",
    zh: "重新提交",
  },
  shipments: {
    en: "Shipments",
    zh: "装运",
  },

  addNew: {
    en: "Add New",
    zh: "新增",
  },
  run: {
    en: "Run",
    zh: "运行",
  },
  plannedQtyWarning: {
    en: "Planned quantity exceeds recommended max",
    zh: "计划数量超出建议最大值",
  },
  enterContainerNumber: {
    en: "Enter container number",
    zh: "输入集装箱号",
  },
  enterDurationDays: {
    en: "Enter duration days",
    zh: "输入持续天数",
  },
  enterRemarksOptional: {
    en: "Enter remarks (optional)",
    zh: "输入备注（可选）",
  },
  shipmentCreatedSuccess: {
    en: "Shipment created successfully",
    zh: "货件创建成功",
  },
  shipmentCreateFailed: {
    en: "Failed to create shipment:",
    zh: "创建货件失败：",
  },
  pleaseFillPlannedQty: {
    en: "Please fill in the Planned Quantity.",
    zh: "请填写计划数量。",
  },
  pleaseSelectProductionLine: {
    en: "Please select a Production Line.",
    zh: "请选择生产线。",
  },
  pleaseEnterDuration: {
    en: "Please enter a Duration.",
    zh: "请输入持续时间。",
  },
  containerNumberRequired: {
    en: "Container number is required",
    zh: "请填写集装箱号",
  },
  etdRequired: {
    en: "ETD is required",
    zh: "请填写预计出货日",
  },
  durationRequired: {
    en: "Duration is required",
    zh: "请填写持续时间",
  },
  pleaseSelectDate: {
    en: "Please select a date.",
    zh: "请选择日期。",
  },
  factoryOrderCreateSuccess: {
    en: "Factory order detail created successfully!",
    zh: "工厂订单明细创建成功！",
  },
  factoryOrderError: {
    en: "Error in factory order detail:",
    zh: "工厂订单明细出错：",
  },

  resolvedDate: {
    en: "Resolved Date",
    zh: "解决日期",
  },
  createdAt: {
    en: "Created Date",
    zh: "查询日期",
  },
  createdBy: {
    en: "User",
    zh: "用户",
  },
  history: {
    en: "History",
    zh: "历史",
  },

  flagged: {
    en: "Flagged",
    zh: "已标记",
  },
  interrupts: {
    en: "Interrupts",
    zh: "中断",
  },
  enquiries: {
    en: "Enquiries",
    zh: "查询",
  },

  askEnquiry: {
    en: "Ask Enquiry",
    zh: "询问",
  },

  createdByName: {
    en: "User",
    zh: "用户",
  },
  generatedBy: {
    en: "Generated By",
    zh: "用户",
  },
  approvedBy: {
    en: "Approved By",
    zh: "批准人",
  },
  updatePriority: {
    en: "Update Priority",
    zh: "更新优先级",
  },
  rejectOrderNumber: {
    en: "Reject Order Number",
    zh: "被拒订单",
  },

  reject: {
    en: "Reject",
    zh: "拒绝",
  },

  accept: {
    en: "Accept",
    zh: "接受",
  },

  enterQuantity: {
    en: "Enter Quantity",
    zh: "输入数量",
  },

  typeYourMessage: {
    en: "Type your message...",
    zh: "输入消息",
  },

  checkList: {
    en: "Checklist",
    zh: "订单清单",
  },

  itemsSelected: {
    en: "Item Selected",
    zh: "已选择商品",
  },

  revise: {
    en: "Revise",
    zh: "修订",
  },
  chinaordernumber: {
    en: "Order Number",
    zh: "订单编号",
  },

  createShipment: {
    en: "Create Shipment",
    zh: "创建货件",
  },

  shipmentNo: {
    en: "Shipment No",
    zh: "发货编号",
  },

  shipmentQty: {
    en: "Shipment Qty",
    zh: "出货数量",
  },

  containerNo: {
    en: "Container No",
    zh: "集装箱号",
  },

  ETA_ToStore: {
    en: "ETA To Store",
    zh: "预计到达时间",
  },

  remarks: {
    en: "Remarks",
    zh: "评论",
  },

  addNewRun: {
    en: "Add New Run",
    zh: "添加新生产",
  },

  addDirectShipment: {
    en: "Add Direct Shipment",
    zh: "添加直接送货",
  },

  interruptType: {
    en: "Interrupt Type",
    zh: "中断类型",
  },

  interruptedBy: {
    en: "Interrupted By",
    zh: "被打断",
  },

  generateShipment: {
    en: "Generate Shipment",
    zh: "生成发货",
  },

  incomingShipment: {
    en: "Incoming Shipment",
    zh: "进货",
  },

  chinaShipment: {
    en: "China Shipment",
    zh: "中国发货",
  },

  globalShipment: {
    en: "Global Shipment",
    zh: "全球发货",
  },

  chinaShipmentDetailsReport: {
    en: "China Shipment Details Report",
    zh: "中国出货详情报告",
  },

  globalShipmentDetailsReport: {
    en: "Global Shipment Details Report",
    zh: "全球发货详情报告",
  },

  vesselVoyage: {
    en: "Vessel / Voyage",
    zh: "船名 / 航次",
  },
  seaFreight: {
    en: "Sea Freight",
    zh: "海运费",
  },
  freightLine: {
    en: "Freight Line",
    zh: "货运线路",
  },
  itemDescription: {
    en: "Item Description",
    zh: "商品描述",
  },
  material: {
    en: "Material",
    zh: "材料",
  },
  label: {
    en: "Feature",
    zh: "特征",
  },
  spec: {
    en: "Spec",
    zh: "规格",
  },
  quantity: {
    en: "Quantity",
    zh: "数量",
  },
  grossWeight: {
    en: "Gross Weight",
    zh: "毛重",
  },
  netWeight: {
    en: "Net Weight",
    zh: "净重",
  },
  notes: {
    en: "Notes",
    zh: "备注",
  },
  noImage: {
    en: "No Image",
    zh: "无图片",
  },
  shipmentDetails: {
    en: "Shipment Details",
    zh: "出货详情",
  },
  items: {
    en: "Items",
    zh: "项目",
  },
  totalPcs: {
    en: "Total Pcs",
    zh: "总件数",
  },
  grossKg: {
    en: "Gross kg",
    zh: "毛重 kg",
  },
  containerInformation: {
    en: "Container Information",
    zh: "集装箱信息",
  },
  exportPdf: {
    en: "Export PDF",
    zh: "导出 PDF",
  },
  ctns: {
    en: "ctns",
    zh: "箱",
  },
  unitPcs: {
    en: "pcs",
    zh: "件",
  },
  unitKg: {
    en: "kg",
    zh: "公斤",
  },
  editShipment: {
    en: "Edit Shipment",
    zh: "编辑出货",
  },
  saveChanges: {
    en: "Save Changes",
    zh: "保存更改",
  },
  noShipmentItemsFound: {
    en: "No shipment items found.",
    zh: "未找到出货项目。",
  },
  dateFilter: {
    en: "Date Filter",
    zh: "日期筛选",
  },
  last6Months: {
    en: "Last 6 Months",
    zh: "最近6个月",
  },
  lastMonth: {
    en: "Last Month",
    zh: "上个月",
  },
  lastWeek: {
    en: "Last Week",
    zh: "上周",
  },
  showHideColumns: {
    en: "Show / Hide Columns",
    zh: "显示 / 隐藏列",
  },
  selectAll: {
    en: "Select All",
    zh: "全选",
  },
  resetOrder: {
    en: "Reset Order",
    zh: "重置顺序",
  },
  filter: {
    en: "Filter",
    zh: "筛选",
  },
  selected: {
    en: "selected",
    zh: "已选择",
  },
  display: {
    en: "Display",
    zh: "显示",
  },
  lastRefresh: {
    en: "Last Refresh",
    zh: "最后刷新",
  },
  carton: {
    en: "CARTON",
    zh: "箱",
  },
  piece: {
    en: "PIECE",
    zh: "件",
  },
  totalPerPallet: {
    en: "Total Per Pallet",
    zh: "每托盘总数",
  },
  perCartonLabel: {
    en: "Per CARTON",
    zh: "按箱",
  },
  perPieceLabel: {
    en: "Per PIECE",
    zh: "按件",
  },
  stock: {
    en: "Stock",
    zh: "库存",
  },
  stockReportDetails: {
    en: "Stock Report Details",
    zh: "库存报告详情",
  },
  product: {
    en: "Product",
    zh: "产品",
  },
  accountStatus: {
    en: "Account Status",
    zh: "账户状态",
  },
  customerCode: {
    en: "Customer Code",
    zh: "客户代码",
  },
  paymentGroup: {
    en: "Payment Group",
    zh: "付款组",
  },
  creditLine: {
    en: "Credit Line",
    zh: "信用额度",
  },
  variance: {
    en: "Variance",
    zh: "差异",
  },
  balance: {
    en: "Balance",
    zh: "余额",
  },
  openDeliveries: {
    en: "Open Deliveries",
    zh: "未结交货",
  },
  committedOrders: {
    en: "Committed Orders",
    zh: "已承诺订单",
  },
  sales: {
    en: "Sales",
    zh: "销售",
  },
  customerStatus: {
    en: "Customer Status",
    zh: "客户状态",
  },
  customerOrder: {
    en: "Customer Order",
    zh: "客户订单",
  },
  poNumber: {
    en: "PO#",
    zh: "采购订单号"
  },
  msNumber: {
    en: "MS#",
    zh: "MS编号"
  },
  poDueDate: {
    en: "PO Due Date",
    zh: "采购订单到期日"
  },
  poWeekNo: {
    en: "PO Week#",
    zh: "采购订单周数"
  },
  poStatus: {
    en: "PO Status",
    zh: "采购订单状态"
  },
  etdDate: {
    en: "ETD",
    zh: "ETD",
  },
  etaPort: {
    en: "ETA Port",
    zh: "ETA Port",
  },
  etaStore: {
    en: "ETA Store",
    zh: "ETA Store",
  },
  deliveredDate: {
    en: "Delivered Date",
    zh: "交付日期",
  },
  shippedQty: {
    en: "Shipped Qty",
    zh: "发货数量",
  },
  shippedQtyCtn: {
    en: "Shipped Qty (Ctn)",
    zh: "发货数量(箱)",
  },
  qtyToShip2: {
    en: "Qty to Ship2",
    zh: "待发货数量2",
  },
  qtyToShipCtn: {
    en: "Qty to Ship (Ctn)",
    zh: "待发货数量(箱)",
  },
  followUp: {
    en: "Follow up",
    zh: "跟进",
  },
  itmsGrpNam: {
    en: "ItmsGrpNam",
    zh: "项目组名称",
  },
  labelType: {
    en: "Label Type",
    zh: "标签类型",
  },
  itemGroup: {
    en: "Item Group",
    zh: "项目组",
  },
  packQty: {
    en: "Pack Qty",
    zh: "包装数量",
  },
  orderedQty: {
    en: "Ordered Qty",
    zh: "订购数量",
  },
  orderedQtyCtn: {
    en: "Ordered Qty (Ctn)",
    zh: "订购数量(箱)",
  },
  totalShippedQty: {
    en: "Total Shipped Qty",
    zh: "总发货数量",
  },
  totalShippedQtyCtn: {
    en: "Total Shipped Qty (Ctn)",
    zh: "总发货数量(箱)",
  },
  shipToAddress: {
    en: "Ship To Address",
    zh: "送货地址",
  },
  poRemarks: {
    en: "PO Remarks",
    zh: "采购订单备注",
  },
  soDueDate: {
    en: "SO Due Date",
    zh: "销售订单到期日",
  },
  operationRemarks: {
    en: "Operation Remarks",
    zh: "操作备注",
  },
  deliveryReport: {
    en: "Delivery Report",
    zh: "交货报告",
  },
  warehouse: {
    en: "Warehouse",
    zh: "仓库",
  },
  document: {
    en: "Document",
    zh: "文件",
  },
  shippingType: {
    en: "Shipping Type",
    zh: "运输类型",
  },
  shippingCode: {
    en: "Shipping Code",
    zh: "运输代码",
  },
  payment: {
    en: "Payment",
    zh: "付款",
  },
  operator: {
    en: "Operator",
    zh: "操作员",
  },
  uom1: {
    en: "Uom1",
    zh: "计量单位1",
  },
  uom2: {
    en: "Uom2",
    zh: "计量单位2",
  },
  batchNumber: {
    en: "Batch number",
    zh: "批号",
  },
  ssccNumber: {
    en: "SSCC number",
    zh: "SSCC编号",
  },
  status: {
    en: "Status",
    zh: "状态",
  },
  aisle: {
    en: "Aisle",
    zh: "通道",
  },
  pmxInventory: {
    en: "PMX Inventory",
    zh: "PMX库存",
  },
  box: {
    en: "Box",
    zh: "箱",
  },
  productionStocks: {
    en: "Production Stocks",
    zh: "生产库存",
  },
  productCode: {
    en: "Product Code",
    zh: "产品代码",
  },
  committed: {
    en: "Committed",
    zh: "已承诺",
  },
  required: {
    en: "Required",
    zh: "所需",
  },
  ordered: {
    en: "Ordered",
    zh: "已订购",
  },
  rawMaterialGroup: {
    en: "Raw Material Group",
    zh: "原材料组",
  },
  rawMaterial: {
    en: "Raw Material",
    zh: "原材料",
  },
  rawMaterials: {
    en: "Raw Materials",
    zh: "原材料",
  },
  total: {
    en: "Total",
    zh: "总计",
  },
  aPET: {
    en: "APET",
    zh: "APET",
  },
  rPET50: {
    en: "RPET50",
    zh: "RPET50",
  },
  rPET80: {
    en: "RPET80",
    zh: "RPET80",
  },
  rPET100: {
    en: "RPET100",
    zh: "RPET100",
  },
  available: {
    en: "Available",
    zh: "可用",
  },
  onWater: {
    en: "On Water",
    zh: "在途",
  },
  onOrder: {
    en: "On Order",
    zh: "已订购",
  },
  pcsCarton: {
    en: "Pcs (Carton)",
    zh: "件 (箱)",
  },
  ctnsPerPallet: {
    en: "Ctns (Pallet)",
    zh: "箱 (托盘)",
  },
  availablePallet: {
    en: "Available (Pallet)",
    zh: "可用 (托盘)",
  },
  inTransit: {
    en: "In Transit",
    zh: "在途",
  },
  onHand: {
    en: "On Hand",
    zh: "库存",
  },
  reserved: {
    en: "Reserved",
    zh: "已预留",
  },
};

export const customerOrderTrackerTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  OrderNumber1: "orderNumber",
  ItemCode: "itemCode",
  ItemName: "itemName",
  BPName: "customerName",
  OrderDate: "orderDate",
  TotalOrdered: "orderQty",
  progress: "progress",
  RequestDate: "requestDate",
  StateDelivery: "location",
  DaysLeft: "daysLeft",
  OrderStatus: "orderStatus",
  trackerActions: "actions",
  trackerActions_sm: "actions",
  NewDueDate: "newDueDate",
  NewOrderQty: "newOrderQty",
  NewShippingDeadline: "newShippingDeadline",
  Reject: "reject",
  Accept: "accept",
  CheckList: "checkList",
};

export const chinaTrackerTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  Revise: "revise",
  ItemsSelected: "itemsSelected",
  CheckList: "checkList",
  TypeYourMessage: "typeYourMessage",
  EnterQuantity: "enterQuantity",
  Accept: "accept",
  Reject: "reject",
  RejectOrderNumber: "rejectOrderNumber",
  RequestDate: "requestDate",
  OrderNumber1: "orderNumber",
  ItemCode: "itemCode",
  ItemName: "itemName",
  BPName: "customerName",
  OrderDate: "orderDate",
  TotalOrdered: "orderQty",
  ETA: "eta",
  StateDelivery: "location",
  OrderStatus: "orderStatus",
  incomingStatus: "incomingStatus",
  PriorityOrder: "priorityOrder",
  MSRef: "msRef",
  MSNo: "msRef",
  ArtworkNo: "artworkNo",
  AllocateProductionLine: "allocateProductionLine",
  QtyToShip: "qtyToShip",
  FulfillmentPercent: "fulfillmentPercent",
  AusInventory: "ausInventory",
  actions: "actions",
  Actions: "actions",
  soakarPad: "soakarPad",
  directShipment: "directShipment",
  labelOrder: "labelOrder",
  Run: "Run",
  PlannedQty: "plannedQuantity",
  plannedQty: "plannedQuantity",
  allocateProductionLine: "allocateProductionLine",
  PlanStartDay: "planStartDay",
  planStartDay: "planStartDay",
  ActualStartDay: "actualStartDay",
  actualStartDay: "actualStartDay",
  ESTCompletion: "estCompletion",
  ESTCompletionDate: "estCompletion",
  ActualCompletionDate: "actualCompletionDate",
  actualCompletionDate: "actualCompletionDate",
  ExpectedArrival: "expectedArrival",
  ESTPack: "estPack",
  ESTPackDate: "estPack",
  ETD: "etd",
  ShippingDeadline: "shippingDeadline",
  shippingDeadline: "shippingDeadline",
  NewShippingDeadline: "newShippingDeadline",
  Customer: "customer",
  Item: "item",
  OrderPlaced: "orderPlaced",
  Subject: "subject",
  Priority: "priority",
  priority: "priority",
  Low: "low",
  High: "high",
  SelectPriority: "selectPriority",
  OrderIssue: "orderIssue",
  ProductInquiry: "productInquiry",
  Other: "other",
  SelectSubject: "selectSubject",
  Message: "message",
  POOrderDate: "poOrderDate",
  DueDate: "dueDate",
  NewDueDate: "newDueDate",
  NewOrderQty: "newOrderQty",
  State: "state",
  OrderQty: "orderQty",
  subject: "subject",
  createdAt: "createdAt",
  createdBy: "createdBy",
  message: "message",
  runOrder: "Run",
  // trackerActions: "actions",
  // trackerActions_sm: "actions",
  resolvedDate: "resolvedDate",
  createdByName: "createdByName",
  Duration: "duration",
  duration: "duration",
  chinaordernumber: "chinaordernumber",
  interruptType: "interruptType",
  interruptedBy: "interruptedBy",
};

export const chinaShipmentTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  status: "statusLabel",
  BPName: "customerName",
  containerNo: "containerNo",
  location: "location",
  ETD: "etd",
  ETA: "eta",
  shippingLine: "shippingLine",
  sealNo: "sealNo",
  generatedBy: "generatedBy",
  createdAt: "createdAt",
  gwTotal: "gwTotal",
  nwTotal: "nwTotal",
  itemCode: "itemCode",
  qtyTotal: "Qty",
  orderNumber: "orderNumber",
  Accept: "accept",
  chinaItemCode: "chinaItemCode",
  globalItemCode: "globalItemCode",
  approvedBy: "approvedBy",
  vesselVoyage: "vesselVoyage",
  freightLine: "freightLine",
  itemDescription: "itemName",
  material: "material",
  spec: "spec",
  label: "label",
  quantity: "quantity",
  grossWeight: "grossWeight",
  netWeight: "netWeight",
  notes: "notes",
  generateShipment: "generateShipment",
};

export const stockReportTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  Location: "location",
  ItemCode: "itemCode",
  ItemName: "itemName",
  FrgnName: "itemDescription",
  CardName: "customerName",
  PerCtns: "pcsCarton",
  PerPallet: "ctnsPerPallet",
  Available2: "available",
  AvaliablePallet: "availablePallet",
  OnWater: "inTransit",
  OnOrder2: "onOrder",
  OnHand: "onHand",
  Delivery: "delivery",
  Reserved: "reserved",
};

export const productReportTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  ItemCode: "itemCode",
  ItemName: "itemName",
  FrgnName: "itemDescription",
  CardName: "customerName",
  PerCtns: "pcsCarton",
  PerPallet: "ctnsPerPallet",
};

export const customerStatusTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  AccountStatus: "accountStatus",
  CardCode: "customerCode",
  CardName: "customerName",
  PymntGroup: "paymentGroup",
  CreditLine: "creditLine",
  Variance: "variance",
  Balance: "balance",
  OpenDeliveries: "openDeliveries",
  CommittedOrders: "committedOrders",
  SlpName: "sales",
};

export const customerOrderTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  PONum: "poNumber",
  MSNum: "msNumber",
  OrderDate: "orderDate",
  PODueDate: "poDueDate",
  POWeekNo: "poWeekNo",
  POStatus: "poStatus",
  OrderStatus: "orderStatus",
  ContainerNo: "containerNo",
  ETDDate: "etdDate",
  ETAPort: "etaPort",
  ETAStore: "etaStore",
  DeliveredDate: "deliveredDate",
  ShippedQty: "shippedQty",
  ShippedQtyCtn: "shippedQtyCtn",
  QtytoShip: "qtyToShip",
  QtytoShip2: "qtyToShip2",
  QtytoShipCtn: "qtyToShipCtn",
  Followup: "followUp",
  ItmsGrpNam: "itmsGrpNam",
  ItemName: "itemName",
  Labeltype: "labelType",
  ItemGroup: "itemGroup",
  PackQty: "packQty",
  OrderedQty: "orderedQty",
  OrderedQtyCtn: "orderedQtyCtn",
  TotalShippedQty: "totalShippedQty",
  TotalShippedQtyCtn: "totalShippedQtyCtn",
  State: "state",
  CustomerCode: "customerCode",
  CustomerName: "customerName",
  ShipToAddress: "shipToAddress",
  PORemarks: "poRemarks",
  SODueDate: "soDueDate",
  OperationRemark: "operationRemarks",
  CardName: "customerName",
  PymntGroup: "paymentGroup",
  CreditLine: "creditLine",
  Variance: "variance",
  Balance: "balance",
  OpenDeliveries: "openDeliveries",
  CommittedOrders: "committedOrders",
};

export const deliveryReportTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  State: "state",
  Warehouse: "warehouse",
  CustomerCode: "customerCode",
  CustomerName: "customerName",
  DocType: "document",
  OrderStatus: "orderStatus",
  RequestDate: "requestDate",
  ShippingType: "shippingType",
  ShipToCode: "shippingCode",
  PaymentTerm: "payment",
  SalesPerson: "sales",
  ProcessBy: "operator",
};

export const pmxInventoryTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  ItemCode: "itemCode",
  ItemName: "itemName",
  Location: "location",
  QuantityUom: "uom1",
  QuantityUom2: "uom2",
  BatchNumber1: "batchNumber",
  SsccNumber: "ssccNumber",
  QuantityStatus: "status",
  StorLocName: "aisle",
};

export const productionStockTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  ItemCode: "itemCode",
  ProdCode: "productCode",
  ItemName: "itemName",
  FrgnName: "itemDescription",
  InStock: "available",
  Committed: "committed",
  Required: "required",
  OnOrder: "ordered",
  Planned: "planned",
};

export const rawMaterialTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  FrgnName: "rawMaterialGroup",
  TotalInstock: "total",
  aPET: "aPET",
  rPET50: "rPET50",
  rPET80: "rPET80",
  rPET100: "rPET100",
};

export const rawMaterialOverviewTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  RawMaterialOverview: "rawMaterial",
  TotalInStock: "total",
  PlannedQty: "planned",
  OnWater: "onWater",
  OnOrder: "onOrder",
};
